import { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { operationBCService } from '../../../services/entityService';
import { OperationBC } from '../types';

// Chargement de l'operation acheteur. Expose un refetch explicite pour rafraichir
// l'etat React apres une action, au lieu du window.location.reload() de l'ancienne infra.
export const useOperationData = () => {
  const { id } = useParams<{ id: string }>();
  const [operation, setOperation] = useState<OperationBC | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [notFound, setNotFound] = useState(false);

  const fetchOperation = useCallback(async () => {
    if (!id) return;
    setLoading(true);
    setError(null);
    setNotFound(false);
    try {
      const data = await operationBCService.getById(id);
      setOperation(data);
    } catch (err) {
      // 404 -> ressource introuvable (page 404 dediee) ; sinon erreur generique.
      if ((err as { status?: number })?.status === 404) {
        setNotFound(true);
      } else {
        setError(err instanceof Error ? err.message : 'Erreur lors du chargement');
      }
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    fetchOperation();
  }, [fetchOperation]);

  return { operation, setOperation, loading, error, notFound, refetch: fetchOperation };
};
